import { render, staticRenderFns } from "./OwnerOnly.vue?vue&type=template&id=2d38baa0&"
import script from "./OwnerOnly.vue?vue&type=script&lang=ts&"
export * from "./OwnerOnly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports